'use client';

import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import Tags from '@alltrails/seo/components/Tags';
import type { PointOfInterestTag, Tag } from '@alltrails/seo/components/Tags/types';
import type { LocationDetailsResponseType } from '@/types/locationDetailsPages/shared';
import getActivityLabel from '@/utils/getActivityLabel';

type Props = {
  slug: string;
  tags: Tag[];
  type: Exclude<LocationDetailsResponseType, 'poi'>;
  locationName: string;
  pointsOfInterest?: PointOfInterestTag[];
  isBot?: boolean;
  heading?: string;
  className?: string;
};

export default function LocationTags({ slug, tags, type, pointsOfInterest, isBot, heading, className, locationName }: Props) {
  const intl = useIntl();

  const formatActivityLabel = useCallback((label: string) => getActivityLabel(intl, locationName, type, label), [intl, locationName, type]);

  return (
    <Tags
      slug={slug}
      tags={tags}
      pointsOfInterest={pointsOfInterest}
      isBot={isBot}
      heading={heading}
      className={className}
      getActivityLabel={formatActivityLabel}
    />
  );
}
